<template>
  <button
    @click="toggleDark"
    class="relative p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-dark-surface transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
    aria-label="Toggle dark mode"
  >
    <transition name="fade" mode="out-in">
      <Sun
        v-if="isDark"
        :size="24"
        class="text-accent transition-transform duration-300 hover:rotate-180"
      />
      <Moon
        v-else
        :size="24"
        class="text-primary transition-transform duration-300 hover:-rotate-12"
      />
    </transition>
  </button>
</template>

<script setup>
import { Moon, Sun } from 'lucide-vue-next';
import { useDarkMode } from '@/composables/useDarkMode';

const { isDark, toggleDark } = useDarkMode();
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.fade-enter-from {
  opacity: 0;
  transform: rotate(-90deg);
}

.fade-leave-to {
  opacity: 0;
  transform: rotate(90deg);
}
</style>
